var utils            = require( './utils' ),
	sticky_title_bar = require( './sticky-title-bar' );

var sticky_header = ( function( $ ) {

	var header_collapsed_height = 160,
		$header,
		$content;

	var _init = function() {
		$header  = $( '#header' );
		$content = $( '#content' );

		// if ( $( '#fp-hero' ).length > 0 ) {
		// 	_setup_fp_header();
		// 	return;
		// }
		//
		// maybe_stick_header();
		//
		// $( window ).smartresize( function() {
		// 	maybe_stick_header();
		// } );
		//
		// $( window ).on( 'scroll', function() {
		// 	maybe_stick_header();
		// } );
	};

	var maybe_stick_header = function () {
		if ( $( 'html' ).hasClass( 'ocm-open' ) ) {
			stick_header( true );
			return;
		}

		if ( utils.viewport_size().width > 992 && $( window ).scrollTop() > 0 ) {
			stick_header( true );
		} else {
			unstick_header();
		}
	};

	var stick_header = function( offset ) {
		$header.addClass( 'sticky' );
		sticky_title_bar.offset_content( offset );
	};

	var unstick_header = function() {
		$header.removeClass( 'sticky' );
		sticky_title_bar.offset_content();
	};

	var _setup_fp_header = function() {
		var $hero = $( '#fp-hero' );

		$( window ).on( 'scroll', function() {
			if ( ! utils.is_in_view( $hero ) ) {
				stick_header( false );
			} else {
				unstick_header();
			}
		} );

		if ( ! utils.is_in_view( $hero ) ) {
			stick_header( false );
		}
	};

	$( document ).ready( _init );

	return {
		collapsed_height : header_collapsed_height,
		stick_header : stick_header,
		unstick_header : unstick_header,
		maybe_stick_header : maybe_stick_header
	};

} )( jQuery );

module.exports = sticky_header;